// Bellanaravela Theme JS

// Cerrar overlay de búsqueda con Escape
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var overlay = document.querySelector('.search-overlay');
    if (overlay) overlay.style.display = 'none';
  }
});

// Sticky header sombra sutil al hacer scroll
window.addEventListener('scroll', function() {
  var header = document.querySelector('header');
  if (!header) return;
  if (window.scrollY > 10) {
    header.style.boxShadow = '0 1px 12px rgba(42,31,26,0.08)';
  } else {
    header.style.boxShadow = 'none';
  }
}, { passive: true });
